'use strict';

import type { Staff } from '../../Entities/Staff/Staff';
import { EntityCollection } from '../EntityCollection';

export class StaffCollection extends EntityCollection<Staff> {}
